import { api } from "./index";

export function getOrder(orderId, params) {
  return api.get(`/order/${orderId}`, { params });
}
